import axios from 'axios';
import * as Config from '../../config';

const state = {
    students: {},
    student: {},
};

const actions = {

    load_Students({commit, dispatch}) {
        return new Promise((resolve, reject) => {

            axios.get(Config.apiPath + 'study/list/all')
                .then(
                    response => {
                        //commit('LOAD_STUDENTS',response.data)
                        resolve(response.data);

                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    load_Student({commit, dispatch}, form) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'study/consult/'+form.id)
                .then(
                    response => {
                        //commit('LOAD_STUDENT', data);
                        resolve(response.data);

                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });

    },
    new_Student({commit, dispatch}, form) {

        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'study/store', form)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    changeActive_Student({commit, dispatch}, form) {

        return new Promise((resolve, reject) => {
            axios.put(Config.apiPath + 'study/change/active/' + form.id + '/' + form.active)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    changeStatus_Student({commit, dispatch}, form) {

        return new Promise((resolve, reject) => {
            axios.put(Config.apiPath + 'study/change/status/' + form.id + '/' + form.status)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    update_Student({commit, dispatch}, form) {

        return new Promise((resolve, reject) => {
            axios.put(Config.apiPath + 'study/update/' + form.id, form)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    delete_Student({commit, dispatch}, form) {
        return new Promise((resolve, reject) => {
            axios.put(Config.apiPath + 'study/change/active/' + form.id + '/' + form.active)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
};

const mutations = {

    LOAD_STUDENTS(state, data) {
        state.students = data;
    },
    LOAD_STUDENT(state, data) {
        state.student = data;
    },

};

export default {
    state,
    actions,
    mutations
};
